// extracted by mini-css-extract-plugin
export default {"headline-label":"HeadlineLabel__headline-label___TM35j"};